import React, { createContext, useMemo, useState, useEffect, ReactNode } from 'react';
import { useCurrentSession } from '../hooks/useCurrentSession';
import { Session } from 'src/api/types/session';

export interface CurrentSessionPlayerContextType {
  isVisible: boolean;
  isLoading: boolean;
  currentSession: Session | null;
}

const CurrentSessionPlayerContext = createContext<CurrentSessionPlayerContextType | undefined>(
  undefined
);

interface CurrentSessionPlayerProviderProps {
  children: ReactNode;
}

export const CurrentSessionPlayerProvider: React.FC<CurrentSessionPlayerProviderProps> = ({
  children
}) => {
  const { currentSession, loading, error } = useCurrentSession();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Determine if the CurrentSessionPlayer should be visible
    const shouldBeVisible = !loading && !error && !!currentSession;
    setIsVisible(shouldBeVisible);
  }, [currentSession, loading, error]);

  const contextValue: CurrentSessionPlayerContextType = useMemo(
    () => ({
      isVisible,
      isLoading: loading,
      currentSession
    }),
    [isVisible, loading, currentSession]
  );

  return <CurrentSessionPlayerContext value={contextValue}>{children}</CurrentSessionPlayerContext>;
};

export { CurrentSessionPlayerContext };
